import { StoreClusterCreatePage } from '@/Components/Pages/ServiceProviderPage/StoreClusterCreatePage';
import { StoreClusterDashboardAdminPage } from '@/Components/Pages/ServiceProviderPage/StoreClusterDashboardAdminPage';
import { StoreClusterDashboardServiceProviderPage } from '@/Components/Pages/ServiceProviderPage/StoreClusterDashboardServiceProviderPage';
import { StoreClusterDetailPage } from '@/Components/Pages/ServiceProviderPage/StoreClusterDetailPage';
import { StoreClusterEditPage } from '@/Components/Pages/ServiceProviderPage/StoreClusterEditPage';
import { StoreClusterPage } from '@/Components/Pages/ServiceProviderPage/StoreClusterPage';
import { Routes } from '@/Routes/types';

export const ServiceProviderAdminPages: Routes = [
    {
        url: 'service-provider',
        sidebar: {
            icon: 'monitoring-ico',
            name: 'ServiceProvider',
        },
        permissions: 'readOnly',
        children: [
            {
                url: 'store-clusters',
                component: <StoreClusterPage />,
                permissions: 'readOnly',
                sidebar: {
                    name: 'Store cluster',
                },
                children: [
                    {
                        url: 'create',
                        component: <StoreClusterCreatePage />,
                        permissions: 'readOnly',
                    },
                    {
                        url: ':id',
                        children: [
                            {
                                url: 'edit',
                                component: <StoreClusterEditPage />,
                                permissions: 'readOnly',
                            },
                            {
                                url: 'detail',
                                component: <StoreClusterDetailPage />,
                                permissions: 'readOnly',
                            },
                        ],
                    },
                    {
                        url: 'dashboard',
                        permissions: 'readOnly',
                        children: [
                            {
                                url: ':id',
                                component: <StoreClusterDashboardAdminPage />,
                                permissions: 'readOnly',
                            },
                        ],
                    },
                ],
            },
        ],
    },
];

export const ServiceProviderPages: Routes = [
    {
        url: 'service-provider',
        sidebar: {
            icon: 'monitoring-ico',
            name: 'ServiceProvider',
        },
        permissions: 'readOnly',
        children: [
            {
                url: 'dashboard',
                permissions: 'readOnly',
                sidebar: {
                    name: 'Dashboard',
                },
                component: <StoreClusterDashboardServiceProviderPage />,
            },
        ],
    },
];
